import React from 'react';
import UserForm from 'components/UserForm';

const AddUser: React.FC = () => <UserForm />;

export default AddUser;
